import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-2 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link to={item.to} className="text-foreground-500 hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-900 font-label" : "text-foreground-500"}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" />}
          </span>
        );
      })}
    </nav>
  );
}